import React from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";

import styles from "./content-word.module.css";
import { State } from "../../redux/store";
import { INTRO_STAGE, PLAY_STAGE } from "../../redux/reducers/stateIdentifiers";
import { srcPath } from "../../util/Path";
import { useImgLoaded } from "../../hooks/CustomHooks";
import IntroductionPage from "./IntroductionPage";
import GamePage from "./GamePage";

const Board = () => {
  const stage = useSelector((state: State) => state.contentWord.stage);
  const [imgLoaded, addImgLoaded] = useImgLoaded(1);

  return (
    <>
      <img
        className={classnames("abs", styles.board)}
        src={srcPath("content-word/board.png")}
        alt=""
        onLoad={addImgLoaded}
      />
      {imgLoaded && stage === INTRO_STAGE && <IntroductionPage />}
      {imgLoaded && stage === PLAY_STAGE && <GamePage />}
    </>
  );
};

export default Board;
